"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowContainer = exports.ItemContainer = exports.GridContainer = exports.FlexBreakContainer = exports.ColumnContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FlexContants = require("./FlexContants");
var _globalTokens = require("../../../shared/global-tokens");
var ItemContainer = exports.ItemContainer = _styledComponents.default.div.withConfig({
  displayName: "Flexstyled__ItemContainer",
  componentId: "sc-h3ko0c-0"
})(["flex:", ";align-self:", ";"], function (_ref) {
  var flex = _ref.flex;
  return flex ? flex : '0 1 auto';
}, function (_ref2) {
  var alignSelf = _ref2.alignSelf;
  return alignSelf;
});
var RowContainer = exports.RowContainer = _styledComponents.default.div.withConfig({
  displayName: "Flexstyled__RowContainer",
  componentId: "sc-h3ko0c-1"
})(["display:flex;flex-direction:row;row-gap:", ";column-gap:", ";flex:", ";flex-wrap:", ";align-items:", ";justify-content:", ";align-self:", ";"], function (_ref3) {
  var rowGap = _ref3.rowGap;
  return rowGap ? _globalTokens.globalGap[rowGap] : _globalTokens.globalSpacing['100'];
}, function (_ref4) {
  var columnGap = _ref4.columnGap;
  return columnGap ? _globalTokens.globalGap[columnGap] : _globalTokens.globalSpacing['100'];
}, function (_ref5) {
  var flex = _ref5.flex;
  return flex ? flex : 1;
}, function (_ref6) {
  var wrap = _ref6.wrap;
  return wrap ? 'wrap' : 'nowrap';
}, function (_ref7) {
  var alignItems = _ref7.alignItems;
  return alignItems ? alignItems : 'center';
}, function (_ref8) {
  var justifyContent = _ref8.justifyContent;
  return justifyContent;
}, function (_ref9) {
  var alignSelf = _ref9.alignSelf;
  return alignSelf;
});
var ColumnContainer = exports.ColumnContainer = _styledComponents.default.div.withConfig({
  displayName: "Flexstyled__ColumnContainer",
  componentId: "sc-h3ko0c-2"
})(["display:flex;flex-direction:column;gap:", ";flex:", ";flex-wrap:", ";align-items:", ";justify-content:", ";align-self:", ";"], function (_ref10) {
  var gap = _ref10.gap;
  return gap ? _globalTokens.globalGap[gap] : _globalTokens.globalSpacing['100'];
}, function (_ref11) {
  var flex = _ref11.flex;
  return flex ? flex : 1;
}, function (_ref12) {
  var wrap = _ref12.wrap;
  return wrap ? 'wrap' : 'nowrap';
}, function (_ref13) {
  var alignItems = _ref13.alignItems;
  return alignItems;
}, function (_ref14) {
  var justifyContent = _ref14.justifyContent;
  return justifyContent;
}, function (_ref15) {
  var alignSelf = _ref15.alignSelf;
  return alignSelf;
});
var GridContainer = exports.GridContainer = _styledComponents.default.div.withConfig({
  displayName: "Flexstyled__GridContainer",
  componentId: "sc-h3ko0c-3"
})(["display:flex;flex-direction:column;gap:", ";"], function (_ref16) {
  var flexType = _ref16.flexType;
  return flexType === _FlexContants.FLEX_GRID_TYPES.SECTIONS ? _globalTokens.globalSpacing['600'] : _globalTokens.globalSpacing['300'];
});
var FlexBreakContainer = exports.FlexBreakContainer = _styledComponents.default.div.withConfig({
  displayName: "Flexstyled__FlexBreakContainer",
  componentId: "sc-h3ko0c-4"
})(["flex-basis:100%;height:0;"]);